var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicsvgDownload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.050000,-0.050000)",
    fill: "#e19b3c",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2268 4591 c-1400 -218 -2178 -1736 -1536 -3000 711 -1399 2689 -1526 3570 -229 1017 1499 -247 3506 -2034 3229z m702 -165 c1286 -247 1954 -1748 1277 -2869 -975 -1615 -3415 -1056 -3585 821 -116 1275 1031 2294 2308 2048z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1780 2910 c-33 -40 -16 -76 68 -140 131 -100 330 -75 420 53 65 93 -60 163 -138 77 -22 -24 -62 -40 -100 -40 -36 0 -87 18 -115 40 -61 48 -101 51 -135 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2891 2903 c-29 -90 104 -193 249 -193 129 0 265 88 256 166 -8 70 -77 82 -149 25 -66 -52 -147 -52 -212 -1 -64 50 -129 51 -144 3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1791 1809 c-37 -38 -40 -72 -7 -105 34 -34 1558 -34 1592 0 36 36 29 92 -15 115 -70 38 -1531 28 -1570 -10z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicsvgDownload2);
export default __webpack_public_path__ + "static/media/picsvg_download(2).37d9f619def0f0f7e3f5e5ef6741c4e1.svg";
export { ForwardRef as ReactComponent };